/* Built In Imports */
/* External Imports */
import { Box, Image, Text } from '@chakra-ui/react';
import MediaEmbedV3 from '@components/Embeds/MediaEmbedV3';
import SectionTitle from '@components/Headings/SectionTitle';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import SingleLineText from '@components/UI/SingleLineText';
import { LeftQuote } from '../components/Icon/LeftQuote';
import config from '@config';
/* Internal Imports */
/* Components */

/**
 * Returns the BenefitsGroup.
 * @param {Object} sectionContent - Content from API
 * @param {string} language - Language of the page
 * @param {string} region - Region of the page
 * @returns {ReactElement} Banner component
 */
const OfferingV1 = ({ sectionContent, region, language }) => {
    return (
        <Box
            //paddingTop={{base:"14%", sm:"14%", lg:"4.5%", md:"4.5%"}}
            //paddingBottom={{ sm: "", base: "", lg: "" }}
            bgImage={{lg:`url(${config.imgPath}/d/46272/1733831558-offer_left_img.png)`,sm:""}}
            bgRepeat={'no-repeat'}
            bgPosition={'left 230px'}
        >
            <Box
                    fontFamily={'FedraSansStd-A-medium'}
                    color="#FFFFFF"
                    fontSize={{ base: "30px", md: "37px", sm: "30px",  lg:"37px" }}
                    mx={{ base: '17px', md: 'auto' }}
                    lineHeight={{base:'41.8px',sm:'39px',md:'41.8px', lg:'41.8px'}}
                    fontWeight='500'
                    textAlign={'center'}
                    paddingTop={{base:'50px' , sm:'50px', lg:'80px', md:"80px"}}
                >
                    {sectionContent[0].titleText}
            </Box>
            <Box 
                //marginTop={{ base: "-20px", sm: "-20px", xl: "-30px" }} 
                margin={{base:'15px auto', sm:"15px auto", lg:"15px auto", md:"15px auto"}}
                maxW={{ sm: "270px", base: "270px", md: "623px" }} 
                mx={"auto"}
                fontSize={{base:"20px",sm:"20px", md:"26px",lg:"26px"}}
                fontFamily="FedraSansStd-book" 
                textAlign="center" 
                color="#FDE6B7"
                lineHeight={{base:"26px",sm:"26px", md:"33.8px", lg:'33.8px'}}
                fontWeight={'400'}
                
            >
                 {sectionContent[1].text}

            </Box>
            <Box marginTop={{ base: "25px", sm: "25px", md: "50px" }} marginBottom={{base:"30px", sm:"30px", md:"50px", lg:"50px"}} textAlign={'center'} className='imgblock'>
                <Image src={sectionContent[2]?.image?.url} width={{base:'201px', md:'auto'}} alt=""/>
            </Box>
            <Box
                color="#FFFFFF"  
                textAlign={'center'} 
                fontFamily={'FedraSansStd-A-medium'}
                margin={{base:"0px auto", sm:"0px auto", md:"10px auto", lg:'10px auto'}}
                fontSize={{lg:'32px',sm:'24px',md:'32px',base:'24px'}}
                fontWeight={'500'}
                lineHeight={{lg:'38px',sm:'30px'}}
                maxW ={{sm:'238px', base:'238px',lg:'537px', md:'537px'}}
                >
                    {sectionContent[3]?.titleText}
             </Box>
               <Box display={'flex'}
                    pos={'relative'}
                    top={{lg:"23px", md:"23px", base:"40px", sm:"40px"}}
                >
                    <MediaEmbedV3 sectionContent={sectionContent[4]} lang={language}
                        width={{ base: '90%', md: '678px' }}
                        style={{ zIndex: "10" }}
                        boxShadow = '#262626 0px 20px 30px -15px'
                    />
                </Box>                   
                <style jsx global>
                {`
                    .imgblock img {
                        display: inline-block !important;
                    }
                        
                `}
            </style>
        </Box>
    );
};

export default OfferingV1;
